import { useState } from "react";
import { useAuthContext } from "../auth/AuthContext";
import { ROLE_LABELS } from "../auth/roles";

export default function ProfilePage() {
  const { user, logout, role, baseRole } = useAuthContext();
  const isOverride = role !== baseRole;
  const [copied, setCopied] = useState(false);
  if (!user) return null;
  const initials = user.name.split(" ").map(w=>w[0]).slice(0,2).join("").toUpperCase();
  const p = { label:"Microsoft Entra", color:"#0078d4", icon:"🪟", desc:"Connecté via Microsoft Entra ID." };
  const copyEmail = () => { navigator.clipboard.writeText(user.email); setCopied(true); setTimeout(()=>setCopied(false),2000); };

  return (
    <div className="screen">
      <div className="screen-inner-sm">
        <h1 className="page-title mb-28">Mon profil</h1>

        <div className="card mb-20">
          <div className="band"/>
          <div style={{ padding:"32px 32px 28px", display:"flex", alignItems:"center", gap:24, borderBottom:"1px solid #f0f0f0" }}>
            {user.avatar
              ? <img src={user.avatar} alt={user.name} style={{ width:80, height:80, borderRadius:"50%", objectFit:"cover", border:"3px solid var(--green)" }}/>
              : <div style={{ width:80, height:80, borderRadius:"50%", background:p.color, border:"3px solid var(--green)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:28, color:"#fff" }} className="t-title">{initials}</div>}
            <div>
              <h2 className="t-title" style={{ fontSize:22, color:"var(--text-primary)", marginBottom:4 }}>{user.name}</h2>
              <div className="flex gap-8" style={{ alignItems:"center", marginBottom:10 }}>
                <span style={{ fontSize:13, color:"var(--text-muted)" }}>{user.email}</span>
                <button onClick={copyEmail} style={{ background:"none", border:"none", cursor:"pointer", fontSize:14, color:copied?"var(--green-dim)":"var(--text-faint)" }} title="Copier">{copied?"✓":"📋"}</button>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                <span style={{ display:"inline-flex", alignItems:"center", gap:5, background:p.color+"15", color:p.color, border:`1px solid ${p.color}30`, borderRadius:6, padding:"3px 10px", fontSize:11, letterSpacing:0.5, textTransform:"uppercase" }} className="t-title">
                  {p.icon} {p.label}
                </span>
                <span style={{ display:"inline-flex", alignItems:"center", gap:5, background:"var(--green-dim)22", color:"var(--green-dim)", border:"1px solid var(--green-dim)44", borderRadius:6, padding:"3px 10px", fontSize:11, letterSpacing:0.5, textTransform:"uppercase" }} className="t-title">
                  {isOverride ? "⚡ " : "🔑 "}{ROLE_LABELS[role]}
                  {isOverride && <span style={{ opacity:0.65, fontSize:10 }}>(réel : {ROLE_LABELS[baseRole]})</span>}
                </span>
              </div>
            </div>
          </div>
          <div style={{ padding:"20px 32px" }}>
            {[{label:"Identifiant",value:user.id},{label:"Méthode",value:p.desc}].map(row=>(
              <div key={row.label} className="flex gap-16" style={{ padding:"12px 0", borderBottom:"1px solid #f8f8f8" }}>
                <span style={{ width:160, fontSize:13, color:"var(--text-muted)", flexShrink:0 }}>{row.label}</span>
                <span style={{ fontSize:13, color:"var(--text-secondary)", wordBreak:"break-all" }}>{row.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <div style={{ padding:"20px 32px 8px" }}>
            <h3 className="t-title t-upper" style={{ fontSize:12, color:"var(--red)", letterSpacing:0.5 }}>Zone Danger</h3>
          </div>
          <div className="flex-between gap-20" style={{ padding:"0 32px 24px" }}>
            <div>
              <p style={{ fontSize:13, color:"var(--text-secondary)", marginBottom:4 }}>Se déconnecter de l'application</p>
              <p style={{ fontSize:11, color:"var(--text-muted)" }}>Votre session sera supprimée.</p>
            </div>
            <button onClick={logout} className="btn btn-danger shrink-0">Déconnexion</button>
          </div>
        </div>
      </div>
    </div>
  );
}
